import { Injectable } from '@angular/core';
import { catchError, Observable, OperatorFunction, throwError } from 'rxjs';
import { SnackbarService } from '@sag-ui';

@Injectable({
    providedIn: 'root'
})
export class HttpHelperService {
    constructor(private snackbarService: SnackbarService) {}

    public handleError<T>(message?: string): OperatorFunction<T, T> {
        return catchError<T, Observable<never>>(error => {
            this.snackbarService.open({
                title: 'Operation unsuccessful',
                description:
                    error.status === 403
                        ? 'You do not have permission to access this resource.'
                        : message ?? 'There was an error while handling your request',
                type: 'error',
                duration: 3000,
                position: 'bottom'
            });
            const handledError = new Error(message || (error.error?.message as string));
            Object.assign(handledError, { status: error.status });
            return throwError(() => handledError);
        });
    }
}
